import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    actions: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    container: {
      display: 'flex',
      gap: theme.spacing(2),
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      margin: theme.spacing(1, 0),
    },
  };
};
